import { scaleOrdinal } from 'd3-scale';
export var DEFAULT_COLOR_SERIES = scaleOrdinal(['#12939A', '#DDB27C', '#88572C', '#FF991F', '#F15C17', '#223F9A']);
//# sourceMappingURL=constants.js.map